// src/pages/login.styled.ts
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const StyledError = styled.span`
    color: red;
    font-size: 0.875rem;
`;

export const LinkContainer = styled.p`
    margin-top: 1rem;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 0.95rem;
`;

export const StyledLink = styled(Link)`
    color: ${({ theme }) => theme.colors.textSecondary};
    text-decoration: underline;
    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const Logo = styled.img`
    padding-top: 0;
    width: 200px;
    height: auto;
    margin: 0;
    cursor: pointer;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    background-color: ${({ theme }) => theme.colors.background};
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
`;

export const Label = styled.label`
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.colors.textSecondary};
    font-family: ${({ theme }) => theme.fonts.secondary}; // Inter
`;

export const Input = styled.input`
    width: 100%;
    font-family: ${({ theme }) => theme.fonts.secondary}; /* Inter */
    padding: 8px;
    border: none;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.inputBackground};
    border: 1px solid ${({ theme }) => theme.colors.border};

    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 1rem;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary};
    }

    &::placeholder {
        text-align: center; /* center the placeholder text */
        font-size: 12px; /* make it 12px */
        /* you can also adjust color if you like:
        color: ${({ theme }) => theme.colors.textSecondary};
        */
    }
`;

export const Button = styled.button<{ isLight: boolean }>`
    font-family: ${({ theme }) => theme.fonts.secondary};
    color: ${({ isLight }) => (isLight ? "#6D6D6D" : "#fff")};
    font-weight: 600;
    padding: 8px;
    background-color: ${({ theme }) => theme.colors.inputBackground};
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.primaryDark};
        color: ${({ isLight }) => (isLight ? "#fff" : "#6D6D6D")};
    }
`;

export const Error = styled.span`
    color: ${({ theme }) => theme.colors.error};
    margin-bottom: 1rem;
`;
